<ng-container *ngIf="notifService.status === 'loading'; then loading"></ng-container>
<ng-container *ngIf="notifService.status === 'error'; then error"></ng-container>

<ng-container *ngIf="notifService.status === 'complete' && (notifService.list$ | async) as notifications">
  <ng-container *ngIf="notifications.length else noNotifications">
    <div class="notification" [class.unread]="!notification.is_read"
         *ngFor="let notification of notifications; trackBy: trackNotification"
         (click)="handleClick(notification, $event)">

      <i [class]="notification.translate === 'newLabReceived' ? 'fas fa-flask pt-3 icon fa-lg' :
                  notification.translate === 'providerFileReceived' ? 'fas fa-stethoscope pt-3 icon fa-lg' :
                  notification.translate === 'sharedLabLink' ? 'fas fa-share pt-3 icon fa-lg' :
                  notification.translate === 'openedSharedLink' ? 'fas fa-check pt-3 icon fa-lg' : 'fas fa-check pt-3 icon'
      " style="color:white;"></i>

      <div class="content">
        <div class="d-flex font-weight-bold">
          <span class="mr-4" style="white-space: normal">
            {{notification.actor || notification.activities[0].lab_name || 'patientLynk'}}
          </span>
          <span *ngIf="isExternal(notification.source)"
                class="badge badge-pill badge-secondary">
            <span transloco="in">in</span>
            patientLynk
          </span>
        </div>
        <small>{{notification.translate ? (notification.translate | transloco) : notification.verb}}</small>
        <span class="content-footer" *ngIf="getPersonById(notification.person) | async as person">
          <span class="text-lowercase" transloco="for">for</span>
          {{ person.first_name }} {{ person.last_name | slice: 0: 1 }}. –
          <span>{{notification.created_at | relativeTime: (lang$ | async) }}</span>
        </span>
      </div>
      <i class="unseen-badge" [class.read]="notification.is_read"></i>
    </div>
    <div *ngIf="notifService.next">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #noNotifications>
  <div class="no-content">
    <i class="fas fa-check fa-lg"></i>
    <span transloco="noNotifications">All caught up! No notifications.</span>
  </div>
</ng-template>

<ng-template #error>
  <div class="no-content">
    <i class="fas fa-exclamation-triangle ab-yellow mb-4" style="font-size: 3rem"></i>
    <span>An error occurred getting your notifications. </span>
    <span *ngIf="notifService.retried">Try again later</span>
    <a *ngIf="!notifService.retried" (click)="onRetry()" class="null">Reload</a>
  </div>
</ng-template>

<ng-template #loading>
  <div class="no-content loading">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</ng-template>
